import React from 'react';
import AboutTop from "../components/About/AboutTop";
import AboutBot from "../components/About/AboutBot";

const About = (props) => {
    // useEffect(() => {
    //     let loadingWrapper = document.getElementById("loadingWrapper")
    //     loadingWrapper.style.display = "flex";

    //     return () => {
    //         dispatch(loading.resetLoading());
    //         loadingWrapper.style.display = "none";
    //     }
    // }, [])
    return (
        <div className='bodyContainer'>
            <AboutTop />
            <AboutBot />
        </div>
    )
}

export default About;
